import React from "react";
import { Modal } from "@shopify/polaris";
import DOMPurify from "dompurify";

function GeneratedContentPreviewModal({ open, onClose, article }) {
  if (!article) return null;

  // Custom styles for modal content, inspired by typical Polaris and .view-article styling
  const modalContentStyles = `
    .Polaris-Modal-Dialog__Modal {
      max-width: 65% !important;
    }
    .article-modal-content {
      line-height: 1.5;
      font-size: 14px;
      color: #2c2c2c;
    }
    .article-modal-content h2 {
      font-weight: 700;
      font-size: 1.45em;
      border-radius: 4px;
      margin-bottom: 12px
    }
    .article-modal-content h3 {
      font-weight: 600;
      font-size: 1.25em;
      margin: 0 0 12px 0;
    }
    .article-modal-content p {
      margin: 0 0 15px 0;
    }
    .article-modal-content ul {
      margin: 0px 0 0px 15px;
      padding-left: 20px;
      list-style-type: disc;
    }
    .article-modal-content li {
      margin-bottom: 8px;
    }
    .article-modal-content strong {
      font-weight: 700;
    }
    .article-modal-content em {
      font-style: italic;
    }
    .article-modal-content br.newline-block {
      display: block;
      margin-bottom: 12px;
    }
    .Polaris-Modal-Header__Title {
      font-size: 17px !important;
    }
  `;

  // Check the article structure for correct access
  const { title, content } = article;

  // Sanitize the article content
  const sanitizedContent = content
    ? DOMPurify.sanitize(content, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'li', 'a', 'h1', 'h2', 'h3', 'span', 'input','button','option', 'select'],
        ALLOWED_ATTR: ['href', 'data-contrast'],
      })
    : 'No content available for this article.';

  // Replace \n\n\n\n with <br class="newline-block"> for consistency with generated content
  const formattedContent = sanitizedContent.replace(/\n\n\n\n/g, '<br class="newline-block">');

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title || 'Article Preview'}
      primaryAction={{
        content: 'Close',
        onAction: onClose,
      }}
    >
      <style>{modalContentStyles}</style>
      <Modal.Section>
        <div
          className="article-modal-content"
          dangerouslySetInnerHTML={{
            __html: formattedContent,
          }}
        />
      </Modal.Section>
    </Modal>
  );
}

export default GeneratedContentPreviewModal;